import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHoreca = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M14.5 16a5.5 5.5 0 0 1 5.5 5.5V35H9V21.5a5.5 5.5 0 0 1 5.5-5.5M23 35v-2h4V22.9a5 5 0 0 1-4-4.9v-5h10v5a5 5 0 0 1-3.999 4.9L29 33h4v2z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M17 8h-5v19h5z"
    />
    <path
      fill="#00C5F2"
      d="M16 22H9v10h7z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHoreca);

export default ForwardRef;
